export default {
  name: 'A6',
  lineHeight: '25px',
  lineHeightDesktop: '40px'
}
